import React, { useContext, useEffect, useState } from 'react';
import { Box, Button, Grid, Paper } from '@mui/material';
import { useSnackbar } from 'notistack';
import { MdAdd } from 'react-icons/md';
import { AuthContext } from '../context/AuthProvider';
import ClientNoData from '../components/Client/ClientNoData';
import { CLIENT_PAGE, DOMAIN_PAGE } from '../utils/commonConstants';
import { getAllClientsApi, getClientByUserGroup } from "../api's/ClientApi";
import ClientTable from '../components/dashboard-component/ClientTable';
import PageHeader from '../reusable-component/PageHeader';
import SearchAndFilter from '../reusable-component/SearchAndFilter';
import LoadingIcon from '../reusable-component/LoadingIcon';
import LLMTable from '../components/dashboard-component/LLMTable';
import { getAllDomainsApi, getDomainByUserGroup } from "../api's/DomainApi";
import AccessModal from '../reusable-component/AccessModal';
import AddEngagementModal from '../reusable-component/AddEngagementModal';
import AddDomainModal from '../reusable-component/AddDomainModal';

const LLMPage = () => {
  const [region, setRegion] = useState('');
  const [status, setStatus] = useState('');
  const [search, setSearch] = useState('');
  //   const [tableData, setTableData] = useState([]);
  //   const [filteredTableData, setFilteredTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [openModal, setOpenModal] = useState(false);
  const [openAccessModal, setOpenAccessModal] = useState(false);
  const [page, setPage] = useState(1);

  const userPermissions = JSON.parse(sessionStorage.getItem('userPermissions') || '[]');
  const hasCreateDomainPermission = userPermissions.includes('CREATE_DOMAIN');

  const tableData = [
    {
      LLM_id: 'llm-1',
      LLM_name: 'OpenAI ChatGPT',
      LLM_title_name: 'ChatGPT',
      created_on: 'Mon Nov 06 2023',
    },
    {
      LLM_id: 'llm-2',
      LLM_name: 'AWS Bedrock',
      LLM_title_name: 'Bedrock',
      created_on: 'Mon Nov 06 2023',
    },
  ];
  const filteredTableData = [
    {
      LLM_id: 'llm-1',
      LLM_name: 'OpenAI ChatGPT',
      LLM_title_name: 'ChatGPT',
      created_on: 'Mon Nov 06 2023',
    },
    {
      LLM_id: 'llm-2',
      LLM_name: 'AWS Bedrock',
      LLM_title_name: 'Bedrock',
      created_on: 'Mon Nov 06 2023',
    },
  ];

  const handleSearch = () => {
    console.log(search);
    // setFilteredTableData(tableData.filter((tableData) => tableData.domain_name.startsWith(search)));
  };

  const handleRegion = (event) => {
    setRegion(event.target.value);
  };

  const handleStatus = (event) => {
    sessionStorage.setItem('filtered_domain_status', event.target.value);
    setStatus(event.target.value);
  };

  const handleOnChange = (event) => {
    sessionStorage.setItem('filtered_domain_search', event.target.value);
    setSearch(event.target.value);
  };

  const handleClearFilter = () => {
    sessionStorage.removeItem('filtered_domain_status');
    sessionStorage.removeItem('filtered_domain_search');
    setRegion('');
    setStatus('');
    setSearch('');
    // setFilteredTableData(tableData);
    setPage(1);
  };

  const data = {
    search,
    handleSearch,
    handleOnChange,
    region,
    handleRegion,
    handleClearFilter,
    handleStatus,
    status,
    firstFilterText: DOMAIN_PAGE.domainFilterByRegion,
    secondFilterText: DOMAIN_PAGE.domainFilterByStatus,
    clearFilterText: DOMAIN_PAGE.domainClearFilterButton,
    firstFilterValues: {
      first: 'us-east-1',
      second: 'us-east-2',
    },
    secondFilterValues: {
      filterData: [...new Set(tableData.map((item) => item.status))],
    },
    isFirstFilterVisible: false,
  };

  const handleAccessModal = () => {
    setOpenAccessModal(!openAccessModal);
  };
  const handleCloseModal = () => {
    setOpenModal(false);
  };
  const handleOpenModal = () => {
    setOpenModal(true);
  };

  return (
    <Box>
      <Grid container direction="row" display="flex">
        <Grid item xs={6} direction="row" justifyContent="flex-start" style={{ color: '#43425D' }}>
          All LLM
        </Grid>
        <Grid item xs={6} display="flex" justifyContent="flex-end">
          {/* <Button
            type="submit"
            variant="contained"
            sx={{ backgroundColor: '#00043C', '&:hover': { backgroundColor: '#00043C' } }}
            onClick={handleOpenModal}
          >
            <MdAdd />
            {DOMAIN_PAGE.addNewDomainButton}
          </Button> */}
        </Grid>
      </Grid>
      {filteredTableData.length !== 0 ? (
        <LLMTable tableData={filteredTableData} currentPage={page} setPage={setPage} />
      ) : (
        !loading && (
          <Paper elevation={3} sx={{ height: '350px', marginTop: '15px' }}>
            <ClientNoData
              title={DOMAIN_PAGE.domainPageNoDataToDisplay}
              text={DOMAIN_PAGE.noDomainToReview}
              addBtnText={DOMAIN_PAGE.addNewDomainButton}
              handleOnClick={handleOpenModal}
              isAddBtn
              disabled={!hasCreateDomainPermission}
            />
          </Paper>
        )
      )}

      <AddDomainModal handleCloseModal={handleCloseModal} openModal={openModal} />
      <AccessModal openAccessModal={openAccessModal} handleAccessModal={handleAccessModal} />
      {loading && <LoadingIcon />}
    </Box>
  );
};

export default LLMPage;
